<template>
    <div class="card">
        <div class="card-body">
            <div class="d-flex align-items-center mb-4">
                <div class="font-weight-bold text-primary mr-3">Тариф {{ company.fare.name }}</div>
                <small class="text-primary">
                    <span v-if="company.fare_next && company.fare_next.id !== company.fare.id">
                        Переход на тариф <b>{{ company.fare_next.name }}</b> c {{ company.fare_next.valid_from | date('DD.MM') }}
                    </span>
                    <span v-else>бессрочный</span>
                </small>
            </div>

            <div class="mb-4" v-if="company.fare.rate && (company.fare.rate.monthly_modem || company.fare.rate.monthly_sim)">
                <p class="h5">
                    {{ company.fare | fareCost }} {{ company.balance_currency | currencySymbol }} в месяц
                </p>

                <small v-if="company.fare.rate && company.fare.rate.monthly_modem" class="d-block text-muted">
                    {{ company.fare.rate.monthly_modem }} {{ company.balance_currency | currencySymbol }} за 1 модем,
                    <span v-if="company.fare.rate.monthly_sim">{{ company.fare.rate.monthly_sim }} {{ company.balance_currency | currencySymbol }} за 1 сим-карту</span><span v-else>плата за сим-карту не взимается</span>
                </small>
            </div>

            <div class="d-flex flex-column flex-lg-row">
                <div class="mb-4 mb-lg-0 flex-fill" v-html="company.fare.description" />
            </div>
        </div>
    </div>
</template>

<script>
export default {
    props: {
        company: {
            type: Object,
            default: _ => ({})
        }
    },

    filters: {
        fareCost(fare) {
            return fare.rate ? (fare.rate.monthly_sim || 0) + (fare.rate.monthly_modem || 0) : 0
        }
    },
}
</script>
